import Default from './Default.json';
import Auth from './Auth.json';
import Button from './Button.json';
import Error from './Error.json';
import Label from './Label.json';

export default {
  ...Default,
  ...Auth,
  ...Button,
  ...Error,
  ...Label,
};
